import { render } from "./RemoveModal.vue?vue&type=template&id=ece10604&scoped=true"
import script from "./RemoveModal.vue?vue&type=script&lang=js"
export * from "./RemoveModal.vue?vue&type=script&lang=js"

import "./RemoveModal.vue?vue&type=style&index=0&id=ece10604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece10604"]])

export default __exports__